
import { mapState } from "vuex";

export default {
	name: "TheBackToTopButton",
	data() {
		return {
			footer: null,
		};
	},
	computed: {
		...mapState("window", ["windowHeight", "scrollY"]),
		isBackToTopVisible() {
			return this.scrollY > this.windowHeight * 2;
		},
		bottom() {
			if (!this.isBackToTopVisible) {
				return null;
			}
			const bottomGap = 15;
			const defaultPosition = 110;
			const scrollPosition =
				this.scrollY + this.windowHeight - defaultPosition;
			const footerTop = this.footer
				? this.footer.offsetTop - bottomGap
				: scrollPosition;
			if (scrollPosition > footerTop) {
				return `${defaultPosition + (scrollPosition - footerTop)}px`;
			}
			return null;
		},
	},
	mounted() {
		this.footer = document.getElementById("footer");
	},
	methods: {
		scrollTop() {
			window?.scrollTo(0, 0);
			window?.dispatchEvent(new CustomEvent("scroll"));
		},
	},
};
